/**
 * Central config for legal / contact pages so the user can customise
 * everything by editing this one file.
 *
 * These values are surfaced on Terms, Privacy, Refund, Cancellation, Contact
 * pages — exactly what CCAvenue's merchant-approval team audits.
 *
 * IMPORTANT: when going live, sync these with:
 *   • Backend `app_settings.gst_config.company_*`
 *   • CCAvenue merchant dashboard contact/address
 *   • Company domain DNS (MX records for the support email)
 */
export const COMPANY = {
  legalName: 'ACF Tourism Pvt Ltd',
  brand:     'ACF Tourism',
  domain:    'acftourism.com',

  // Registered address — sync with GSTIN-registered address
  address:   'Unit no. 12, Nesbit Rd, Tarwadi, Mazgaon, Mumbai, Maharashtra 400010',
  city:      'Mumbai',
  state:     'Maharashtra',
  country:   'India',

  // Registration numbers — fill with real values before launch
  cin:       '[CIN to be added]',
  gstin:     '27AFAPV2647H1Z9',
  pan:       'AFAPV2647H',
  iataCode:  '[IATA code if applicable]',

  // Support channels
  phone:     '+91 22 3786 0300',
  phoneHours:'Mon – Sat, 10:00 AM to 07:00 PM IST',
  supportEmail: 'support@acftourism.com',
  salesEmail:   'sales@acftourism.com',
  legalEmail:   'legal@acftourism.com',
  grievanceOfficer: {
    name:  '[Grievance Officer Name]',
    email: 'grievance@acftourism.com',
    phone: '+91 22 3786 0300',
  },

  // Governing jurisdiction
  jurisdiction: 'Mumbai, Maharashtra, India',

  // Site URLs (referenced inside content)
  urls: {
    terms:        '/terms',
    privacy:      '/privacy',
    refund:       '/refund-policy',
    cancellation: '/cancellation-policy',
    contact:      '/contact-us',
  },
};

export const LAST_UPDATED = '23 April 2026';
